<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { siteUrl } from '@/configs/urls'

const router = useRouter()

const redirectToHomePage = () => {
  const TIMEOUT_MS = 3000
  setTimeout(() => {
    router.push('/')
  }, TIMEOUT_MS)
}

document.title = '404 not found!'

onMounted(() => {
  redirectToHomePage()
})
</script>

<template>
  <div
    class="min-h-[60vh] lg:min-h-screen flex lg:items-center justify-center relative pt-10 lg:pt-0"
  >
    <section
      class="w-full h-full flex flex-col lg:flex-row justify-center lg:justify-between items-center"
    >
      <div class="flex flex-col items-center lg:items-start lg:self-center">
        <span class="text-[#2E2EE5] text-[96px] lg:text-[128px] font-extrabold font-fa">404</span>
        <p
          class="lg:leading-20 text-center lg:text-start text-[#2E2EE5] text-2xl lg:text-5xl font-bold lg:max-w-md mb-8"
        >
          صفحه مورد نظر شما<br />
          یافت نشد
        </p>
        <a
          :href="siteUrl('/')"
          class="rounded-full cursor-pointer flex items-center justify-center min-w-[180px] border-2 border-[#2E2EE5] text-[#2E2EE5] h-[64px] px-6 text-[22px] font-bold hover:bg-gray-100 transition-colors duration-300"
        >
          بازگشت به خانه
        </a>
      </div>
    </section>
  </div>
</template>
